module.exports = __webpack_public_path__ + "static/media/wd17.047a93b1.jpeg";